import { render, staticRenderFns } from "./uploadPhoto.vue?vue&type=template&id=12419f14&scoped=true"
import script from "./uploadPhoto.vue?vue&type=script&lang=js"
export * from "./uploadPhoto.vue?vue&type=script&lang=js"
import style0 from "./uploadPhoto.vue?vue&type=style&index=0&id=12419f14&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12419f14",
  null
  
)

export default component.exports